export default "__VITE_ASSET__DcTZdUhO__"